import React, { useState } from 'react'
import { Form, Button, Card, Alert, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [showForgotPassword, setShowForgotPassword] = useState(false)
  const [resetEmail, setResetEmail] = useState('')
  const [resetLoading, setResetLoading] = useState(false)
  const [resetSent, setResetSent] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    if (error) {
      setError(error.message)
    } else {
      navigate('/')
    }
    setLoading(false)
  }

  const handleForgotPassword = async (e) => {
    e.preventDefault()
    setResetLoading(true)
    setError('')

    if (!resetEmail) {
      setError('Veuillez entrer votre adresse email')
      setResetLoading(false)
      return
    }

    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: `${window.location.origin}/reset-password`,
    })

    if (error) {
      setError(error.message)
    } else {
      setResetSent(true)
      setSuccess('Un lien de réinitialisation a été envoyé à votre adresse email')
    }
    setResetLoading(false)
  }

  const closeResetModal = () => {
    setShowForgotPassword(false)
    setResetEmail('')
    setResetSent(false)
    setError('')
    setSuccess('')
  }

  return (
    <div className="login-page">
      {/* Background sportif vert et blanc */}
      <div className="login-background">
        <div className="sports-overlay"></div>
      </div>
      
      {/* Container centré */}
      <div className="login-center-container">
        <Card className="login-card shadow-lg border-0">
          <Card.Body className="p-5">
            
            {/* En-tête avec logo sportif */}
            <div className="text-center mb-4">
              <div className="login-logo mb-3">
                <div className="logo-circle">
                  <span className="logo-icon">⚽</span>
                </div>
              </div>
              <h2 className="login-title">Street Sport Luxembourg</h2>
              <p className="login-subtitle text-muted">
                Espace Staff - Gestion des Présences
              </p>
            </div>

            {/* Messages d'alerte */}
            {error && (
              <Alert variant="danger" className="alert-custom">
                <i className="bi bi-exclamation-triangle me-2"></i>
                {error}
              </Alert>
            )}
            {success && (
              <Alert variant="success" className="alert-custom">
                <i className="bi bi-check-circle me-2"></i>
                {success}
              </Alert>
            )}

            {/* Formulaire de connexion */}
            <Form onSubmit={handleLogin} className="login-form">
              
              {/* Champ Email */}
              <Form.Group className="mb-4">
                <Form.Label className="form-label-custom">
                  <i className="bi bi-envelope me-2"></i>
                  Adresse email
                </Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="votre@email.com"
                  className="form-control-custom"
                />
              </Form.Group>

              {/* Champ Mot de passe */}
              <Form.Group className="mb-3">
                <Form.Label className="form-label-custom">
                  <i className="bi bi-lock me-2"></i>
                  Mot de passe
                </Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Votre mot de passe"
                  className="form-control-custom"
                />
              </Form.Group>

              {/* Lien mot de passe oublié */}
              <div className="text-end mb-4">
                <Button
                  variant="link"
                  onClick={() => setShowForgotPassword(true)}
                  className="forgot-password-link"
                >
                  <i className="bi bi-key me-1"></i>
                  Mot de passe oublié ?
                </Button>
              </div>

              {/* Bouton de connexion */}
              <Button
                variant="success"
                type="submit"
                className="login-btn w-100"
                disabled={loading}
                size="lg"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Connexion...
                  </>
                ) : (
                  <>
                    <i className="bi bi-box-arrow-in-right me-2"></i>
                    Se connecter
                  </>
                )}
              </Button>

            </Form>

            {/* Footer */}
            <div className="text-center mt-4 pt-3 border-top">
              <small className="text-muted">
                © 2025 Street Sport Luxembourg • Sports Urbains • Fitness • Bien-être
              </small>
            </div>

          </Card.Body>
        </Card>
      </div>

      {/* Modal Mot de passe oublié */}
      <Modal show={showForgotPassword} onHide={closeResetModal} centered className="password-modal">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center">
            <i className="bi bi-key-fill text-success me-2"></i>
            Réinitialisation du mot de passe
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleForgotPassword}>
          <Modal.Body className="px-4 pb-3">
            {resetSent ? (
              <div className="text-center py-3">
                <div className="success-icon mb-3">
                  <i className="bi bi-envelope-check text-success"></i>
                </div>
                <h5 className="text-success mb-2">Email envoyé !</h5>
                <p className="text-muted mb-0">
                  Un lien de réinitialisation a été envoyé à <br/>
                  <strong>{resetEmail}</strong>
                </p>
                <p className="text-muted small mt-2">
                  Vérifiez votre boîte de réception et vos spams.
                </p>
              </div>
            ) : (
              <>
                <p className="text-muted text-center mb-4">
                  Entrez votre adresse email pour recevoir un lien de réinitialisation sécurisé.
                </p>
                <Form.Group>
                  <Form.Label>Adresse email</Form.Label>
                  <Form.Control
                    type="email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    placeholder="votre@email.com"
                    required
                    className="form-control-custom"
                  />
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            {!resetSent ? (
              <>
                <Button 
                  variant="outline-secondary" 
                  onClick={closeResetModal}
                  className="flex-fill"
                >
                  Annuler
                </Button>
                <Button 
                  variant="success" 
                  type="submit" 
                  disabled={resetLoading}
                  className="flex-fill"
                >
                  {resetLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Envoi...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2"></i>
                      Envoyer le lien
                    </>
                  )}
                </Button>
              </>
            ) : (
              <Button 
                variant="success" 
                onClick={closeResetModal} 
                className="w-100"
              >
                <i className="bi bi-check-lg me-2"></i>
                Compris
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Styles CSS intégrés - COULEURS VERT ET BLANC */}
      <style jsx>{`
        .login-page {
          min-height: 100vh;
          background: 
            linear-gradient(135deg, rgba(34, 139, 34, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%),
            url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><rect fill="%23228B22" width="1200" height="800"/><path fill="%23FFFFFF" d="M0,400L1200,200L1200,800L0,800Z"/></svg>');
          position: relative;
          overflow: hidden;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .login-center-container {
          width: 100%;
          max-width: 440px;
          position: relative;
          z-index: 2;
        }

        .login-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            /* Éléments sportifs verts */
            radial-gradient(circle at 15% 20%, rgba(34, 139, 34, 0.15) 0%, transparent 25%),
            radial-gradient(circle at 85% 30%, rgba(50, 205, 50, 0.15) 0%, transparent 25%),
            
            /* Mouvements sportifs */
            radial-gradient(ellipse at 25% 70%, rgba(144, 238, 144, 0.1) 0%, transparent 30%),
            radial-gradient(ellipse at 75% 60%, rgba(152, 251, 152, 0.1) 0%, transparent 30%),
            
            /* Éléments centraux */
            radial-gradient(circle at 50% 40%, rgba(34, 139, 34, 0.08) 0%, transparent 35%),
            
            /* Éléments graphiques sportifs */
            linear-gradient(45deg, transparent 65%, rgba(255, 255, 255, 0.05) 65%, rgba(255, 255, 255, 0.05) 67%, transparent 67%),
            linear-gradient(-45deg, transparent 65%, rgba(34, 139, 34, 0.05) 65%, rgba(34, 139, 34, 0.05) 67%, transparent 67%),
            linear-gradient(135deg, transparent 65%, rgba(255, 255, 255, 0.05) 65%, rgba(255, 255, 255, 0.05) 67%, transparent 67%);
          
          animation: backgroundPulse 8s ease-in-out infinite;
        }

        .sports-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            /* Éléments sportifs */
            radial-gradient(circle at 20% 25%, rgba(34, 139, 34, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 75%, rgba(50, 205, 50, 0.15) 0%, transparent 50%),
            
            /* Éléments de terrain */
            repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              rgba(144, 238, 144, 0.02) 10px,
              rgba(144, 238, 144, 0.02) 20px
            ),
            
            /* Éléments de filet */
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 15px,
              rgba(255, 255, 255, 0.02) 15px,
              rgba(255, 255, 255, 0.02) 30px
            );
        }

        @keyframes backgroundPulse {
          0%, 100% { 
            opacity: 0.8;
            transform: scale(1);
          }
          50% { 
            opacity: 1;
            transform: scale(1.02);
          }
        }

        .login-card {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          border: 1px solid rgba(34, 139, 34, 0.1);
          animation: cardEntrance 0.8s ease-out;
          box-shadow: 
            0 25px 50px rgba(34, 139, 34, 0.2),
            0 0 0 1px rgba(255, 255, 255, 0.1);
        }

        @keyframes cardEntrance {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .login-logo {
          display: flex;
          justify-content: center;
        }

        .logo-circle {
          width: 90px;
          height: 90px;
          background: linear-gradient(135deg, #228B22, #32CD32, #90EE90);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 
            0 15px 35px rgba(34, 139, 34, 0.3),
            0 0 0 4px rgba(255, 255, 255, 0.1);
          animation: logoSport 3s ease-in-out infinite;
          position: relative;
        }

        .logo-circle::before {
          content: '';
          position: absolute;
          top: -4px;
          left: -4px;
          right: -4px;
          bottom: -4px;
          background: linear-gradient(135deg, #228B22, #32CD32, #90EE90, #FFFFFF);
          border-radius: 50%;
          z-index: -1;
          animation: logoRing 2s linear infinite;
        }

        @keyframes logoSport {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg) scale(1);
          }
          25% { 
            transform: translateY(-8px) rotate(-5deg) scale(1.05);
          }
          75% { 
            transform: translateY(-5px) rotate(5deg) scale(1.03);
          }
        }

        @keyframes logoRing {
          0% { 
            opacity: 0.8;
            transform: scale(1);
          }
          50% { 
            opacity: 0.4;
            transform: scale(1.1);
          }
          100% { 
            opacity: 0.8;
            transform: scale(1);
          }
        }

        .logo-icon {
          font-size: 3rem;
          filter: brightness(0) invert(1);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        .login-title {
          font-weight: 800;
          color: #228B22;
          font-size: 1.9rem;
          margin-bottom: 0.5rem;
          background: linear-gradient(135deg, #228B22, #32CD32, #90EE90);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          letter-spacing: 0.5px;
        }

        .login-subtitle {
          font-size: 0.95rem;
          font-weight: 500;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .form-label-custom {
          font-weight: 700;
          color: #228B22;
          margin-bottom: 0.5rem;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .form-control-custom {
          border: 2px solid #e8f5e8;
          border-radius: 12px;
          padding: 14px 16px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #fff;
          font-weight: 500;
        }

        .form-control-custom:focus {
          border-color: #32CD32;
          box-shadow: 0 0 0 3px rgba(50, 205, 50, 0.1);
          transform: translateY(-2px);
        }

        .forgot-password-link {
          color: #32CD32;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .forgot-password-link:hover {
          color: #228B22;
          transform: translateX(3px);
        }

        .login-btn {
          background: linear-gradient(135deg, #228B22, #32CD32, #90EE90);
          border: none;
          border-radius: 12px;
          padding: 16px 20px;
          font-weight: 700;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(34, 139, 34, 0.3);
          text-transform: uppercase;
          letter-spacing: 0.5px;
          position: relative;
          overflow: hidden;
        }

        .login-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s;
        }

        .login-btn:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(34, 139, 34, 0.5);
        }

        .login-btn:hover::before {
          left: 100%;
        }

        .login-btn:active {
          transform: translateY(-1px);
        }

        .alert-custom {
          border-radius: 12px;
          border: none;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .password-modal .modal-content {
          border-radius: 20px;
          border: none;
          box-shadow: 0 25px 60px rgba(34, 139, 34, 0.2);
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
        }

        .success-icon {
          font-size: 3.5rem;
          color: #228B22;
          animation: successPop 0.6s ease-out;
        }

        @keyframes successPop {
          0% { transform: scale(0) rotate(-180deg); opacity: 0; }
          70% { transform: scale(1.2) rotate(10deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); opacity: 1; }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .login-center-container {
            max-width: 400px;
            margin: 0 20px;
          }
          
          .login-card {
            padding: 2rem !important;
          }
          
          .login-title {
            font-size: 1.6rem;
          }
          
          .logo-circle {
            width: 80px;
            height: 80px;
          }
          
          .logo-icon {
            font-size: 2.5rem;
          }
        }

        @media (max-width: 576px) {
          .login-center-container {
            max-width: 350px;
            margin: 0 15px;
          }
          
          .login-card .card-body {
            padding: 1.5rem !important;
          }
          
          .login-title {
            font-size: 1.4rem;
          }
        }

        @media (max-width: 400px) {
          .login-center-container {
            max-width: 100%;
            margin: 0 10px;
          }
        }
      `}</style>
    </div>
  )
}